import { render } from "./AdminCaseTable.vue?vue&type=template&id=7ca2a202&scoped=true"
import script from "./AdminCaseTable.vue?vue&type=script&lang=js"
export * from "./AdminCaseTable.vue?vue&type=script&lang=js"

import "./AdminCaseTable.vue?vue&type=style&index=0&id=7ca2a202&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca2a202"]])

export default __exports__